import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
const testimonials = [{
  id: 1,
  name: 'Sofía L.',
  treatment: 'Estética Dental',
  quote: 'Nunca pensé que ir al dentista podría sentirse como visitar un spa de lujo. El resultado de mis carillas es simplemente una obra de arte.',
  img: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&q=80'
}, {
  id: 2,
  name: 'Martín G.',
  treatment: 'Implantes 3D',
  quote: 'La tecnología que utilizan es de otro planeta. Cero dolor, recuperación inmediata y un trato verdaderamente VIP desde el primer minuto.',
  img: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&q=80'
}, {
  id: 3,
  name: 'Valentina R.',
  treatment: 'Ortodoncia Invisible',
  quote: 'Buscaba discreción y resultados rápidos. El equipo de Lumière superó todas mis expectativas. Mi nueva sonrisa me ha cambiado la vida.',
  img: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&q=80'
}, {
  id: 4,
  name: 'Diego M.',
  treatment: 'Rehabilitación Completa',
  quote: 'Profesionalismo absoluto. El ambiente oscuro y relajante te quita cualquier ansiedad. Son los mejores en lo que hacen, sin duda.',
  img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80'
}];
export function Testimonials() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(scrollRef, {
    once: true
  });
  return <section id="testimonios" className="py-24 bg-night-800 relative z-20 overflow-hidden" data-id="element-123">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-12" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-125">
          <h2 className="font-serif text-4xl md:text-5xl text-white mb-4" data-id="element-126">
            Sonrisas que Hablan <br data-id="element-127" />
            <span className="text-gold italic" data-id="element-128">por Sí Mismas</span>
          </h2>
        </motion.div>
      </div>

      {/* Carousel Container */}
      <div className="pl-6 md:pl-12 pb-8" data-id="element-129">
        <motion.div ref={scrollRef} className="flex gap-6 overflow-x-auto snap-x snap-mandatory scrollbar-hide pr-6 md:pr-12" initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {
        opacity: 0
      }} transition={{
        duration: 1
      }} data-id="element-130">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.id} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="min-w-[300px] md:min-w-[400px] bg-night-900 p-8 rounded-xl snap-start border border-night-700 hover:border-gold/30 transition-colors duration-300" data-id="element-131">
              <div className="flex items-center gap-4 mb-6" data-id="element-132">
                <img src={testimonial.img} alt={testimonial.name} className="w-16 h-16 rounded-full object-cover border-2 border-gold/50" data-id="element-133" />
                <div data-id="element-134">
                  <h4 className="font-serif text-lg text-white" data-id="element-135">
                    {testimonial.name}
                  </h4>
                  <p className="font-sans text-xs text-gold uppercase tracking-wider" data-id="element-136">
                    {testimonial.treatment}
                  </p>
                </div>
              </div>
              <p className="font-sans text-pearl/80 italic leading-relaxed" data-id="element-137">
                "{testimonial.quote}"
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}